// jshint module: true

// Enable CustomEvent() constructor in IE
function CustomEvent(event, params) {
  let evt;

  params = params || { bubbles: false, cancelable: false, detail: undefined };
  evt = document.createEvent('CustomEvent');
  evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);

  return evt;
}

if (typeof window.CustomEvent !== 'function') {
  CustomEvent.prototype = window.EventPrototype;
  window.customEvent = CustomEvent;
}



// WEBPACK FOOTER //
// ./website/assets/scripts/polyfills/custom-events-ie.js